import { getTotalPriceOfOrderTicketLines } from '../../utils/tickets/order-ticket-line-utils';
import { getOrderTickets } from './get-order-tickets';
export const getOrderTicketsTotalPrice = () => getTotalPriceOfOrderTicketLines(getOrderTickets());
//# sourceMappingURL=get-order-tickets-total-price.js.map